<div class="center-xy" [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
    *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="additional-contact-info">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <img ngSrc="/assets/img/zone_icons/relay.svg"
                    width="45" height="45" alt="" />
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                {{ zones.selectedZone.description.name }}
            </p>
        </div>

        <div class="zone-control__content">
            <div class="zone-control__buttons-top">
                <div class="zone-control__close-button cursor-pointer bg-cancel bg-cancel__button"
                    data-testid="back-button"
                    (click)="zones.goBack()">
                    <img ngSrc="/assets/img/zone_icons/back_without_border.svg"
                        width="40" height="40" alt="" />
                </div>
            </div>

            <div class="dropdown-list dropdown-list--info">
                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(8309) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            <img class="dropdown-list__signal dropdown-list__signal--no-margin"
                                data-testid="signal-icon"
                                ngSrc="{{zones.signalIcon({
                                    signalStrength: zones.selectedZone.tile.signalStrength}) }}"
                                width="19" height="19" alt="" />
                        </p>
                    </div>
                </div>

                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(2830) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            <span *ngIf="zones.selectedZone.tile.relayState === 'on'">
                                {{ subtitle(1447) }}
                            </span>
                            <span *ngIf="zones.selectedZone.tile.relayState === 'off'">
                                {{ subtitle(924) }}
                            </span>
                        </p>
                    </div>
                </div>

                <div class="dropdown-list__item color-basic font-12 font-bold">
                    <p class="dropdown-list__item-name">
                        {{ subtitle(814) }}
                    </p>
                    <div class="dropdown-list__value dropdown-list__value--single">
                        <p class="dropdown-list__value-name">
                            {{ zonesSystem.setWorkTypeSubtitle(zones.selectedZone.tile.workType) }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
